import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SKIP_ERROR_HANDLER } from '../core/interceptors/error.interceptor';

@Injectable({
  providedIn: 'root'
})
export class HitoProyectoService {

  constructor(private readonly http: HttpClient) { }

  public findHitosProyectoByEmail(email: string): Observable<any> {
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/hito-proyectos/persona/" + email);
  }

  public findHitosProyectUserNameWeek(page: number, size: number, email: string, silent?: boolean): Observable<any>;
  public findHitosProyectUserNameWeek(page: number, size: number, email: string, startDate: string, endDate: string, silent?: boolean): Observable<any>;
  public findHitosProyectUserNameWeek(
    page: number,
    size: number,
    email: string,
    arg4?: boolean | string,
    arg5?: string | boolean,
    arg6?: boolean
  ): Observable<any> {
    let startDate: string | undefined;
    let endDate: string | undefined;
    let silent = false;

    if (typeof arg4 === 'string' && typeof arg5 === 'string') {
      startDate = arg4;
      endDate = arg5 as string;
      silent = typeof arg6 === 'boolean' ? arg6 : false;
    } else if (typeof arg4 === 'boolean') {
      silent = arg4;
    }

    let url = environment.backEndHost + environment.serverEndPoint + "/hitosByProyectUserNameWeek?page=" + (page - 1) + "&size=" + size + "&userName=" + email;
    if (startDate && endDate) {
      url += "&startDate=" + startDate + "&endDate=" + endDate;
    }

    return this.http.get(url, silent ? { context: new HttpContext().set(SKIP_ERROR_HANDLER, true) } : {});
  }

  /**
   * Lista las tareas activas del usuario para registrar tiempo, sin filtro de fecha.
   * El backend excluye Done (100%) y Backlog (0% no bloqueado); incluye bloqueadas con avance < 100%.
   */
  public findHitosActivasByUserName(page: number, size: number, email: string, silent: boolean = false): Observable<any> {
    const url = environment.backEndHost + environment.serverEndPoint + "/hitosActivasByUserName?page=" + (page - 1) + "&size=" + size + "&userName=" + email;
    return this.http.get(url, silent ? { context: new HttpContext().set(SKIP_ERROR_HANDLER, true) } : {});
  }

}
